<div class="tutorial-tile d-flex p-4 my-3 flex-column w-100 justify-content-between">
    <h4 class="mb-3">{{ tutorial.name }}</h4>
    <ca-call-to-action [innerText]="'Start the tour'" (click)="openTutorial(tutorial)"></ca-call-to-action>
</div>
